import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLabels } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';
import CompareContent from './CompareContent';
import { selectIsTabbedLayout } from '../../../../../features/layoutSlice';

const ModernMyCarsLabel = ({ selected, handleChange, uuid }) => {
	const labels = useLabels();
	const isTabbedLayout = useSelector((state) => selectIsTabbedLayout(state));

	const isInline = !isTabbedLayout;

	const modernMyCarsIcon = selected
		? 'ddc-icon-checkmark2'
		: 'ddc-icon-checkmark2-outline';

	const modernMyCarsIconClasses = [
		'ddc-icon',
		modernMyCarsIcon,
		'ddc-icon-size-default'
	];

	const modernMyCarsCtasBtnClasses = [
		'd-flex ',
		isInline ? 'flex-row' : 'flex-column',
		'align-items-center',
		'py-1',
		'px-1'
	];

	const modernMyCarsCtasBtnLabelClasses = [
		isInline ? 'ml-3' : '',
		'label-text',
		'ddc-font-size-small',
		'font-weight-normal'
	];

	return (
		<>
			<div className="d-flex align-items-center">
				<button
					type="button"
					className="modern-my-cars-compare-label"
					onClick={(e) => handleChange(e)}
					id={`${uuid}-compare`}
				>
					<span className={setClassNames(modernMyCarsCtasBtnClasses)}>
						<i
							data-testid="modern-my-cars-compare-label-icon"
							className={setClassNames(modernMyCarsIconClasses)}
							aria-hidden="true"
						/>
						<span
							className={setClassNames(
								modernMyCarsCtasBtnLabelClasses
							)}
						>
							{labels.get('COMPARE')}
						</span>
					</span>
				</button>
				{isInline ? (
					<CompareContent selected={selected} isInline={isInline} />
				) : null}
			</div>
		</>
	);
};

ModernMyCarsLabel.propTypes = {
	uuid: PropTypes.string.isRequired,
	selected: PropTypes.bool.isRequired,
	handleChange: PropTypes.func.isRequired
};

export default ModernMyCarsLabel;
